import React, { useState, useContext, useEffect } from 'react';
import { Modal, Button, Input } from 'antd';
import { ModalBody, Container, ModalContainer, InputContainer, InputLabel, PasswordContainer } from './styles';
import { VerifyPassword, updatePassword } from '../../utils/services/authAPI';
import { withTranslation } from 'react-i18next';
import { CHANGE_PASSWORD_MODAL } from "./translationValues"
import md5 from 'md5';
import Session from "supertokens-web-js/recipe/session";
import PasswordStrengthBar from '../../components/PasswordStrengthBar/PasswordStrengthBar';
import {  PASSWORD_MAX_LENGTH } from '../../utils/helper';

const ChangePasswordModal = props => {
  const { visible, onCancel,t } = props;
  const [password, setPassword] = useState({ old: '', new: '', confirm: '' });
  const [passwordVerify, setPasswordVerify] = useState(false)
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [FormValidityCheck, setFormValidityCheck] = useState(true);
  const [PasswordScore, setPasswordScore] = useState('');
  const [PasswordUpdateSuccess, setPasswordUpdateSuccess] = useState(false);

  const handlePassword = e => {
    const { value, name } = e.target;
    let updatedValue = { ...password };
    updatedValue[name] = value;
    setPassword(updatedValue);

    if (password.confirm.length === 0 || name === 'old') return;
    passwordValidation(password.new, value)
  };

  const submitPassword = async () => {

    if (password.new !== password.confirm) {
      setError(t(CHANGE_PASSWORD_MODAL.PASSWORD_MISMATCH_ERROR_MESSAGE.key, CHANGE_PASSWORD_MODAL.PASSWORD_MISMATCH_ERROR_MESSAGE.value));
      return;
    }

    const oldPasswordStatus = await verifyOldPaaword();
    if (oldPasswordStatus) {
      return
    }

    if (password.new === password.old) {
      setError(t(CHANGE_PASSWORD_MODAL.PASSWORD_VALIDATION_ERROR_MESSAGE.key, CHANGE_PASSWORD_MODAL.PASSWORD_VALIDATION_ERROR_MESSAGE.value));
      return;
    }

    setLoading(true);
    let response = await updatePassword({ "password": md5(password.confirm) });
    if (response?.isUpdated) {
      setPasswordUpdateSuccess(true);
      setTimeout(async () => {
        onCancel();
        await Session.signOut();
      }, 1000);
    }

    setLoading(false);
  };

  const handleKeyPress = e => {
    if (e.key === 'Enter') {
      submitPassword();
    }
  };

  const verifyOldPaaword = async () => {
    const response = await VerifyPassword({ "password": md5(password.old) })

    if (response) {
      setPasswordVerify(!response?.isVerified);
      return (!response?.isVerified)
    }
  }

  const passwordValidation = (password, confirmPassword) => {
    if (password === confirmPassword) {
      setError('');
    } else {
      setError(t(CHANGE_PASSWORD_MODAL.PASSWORD_MISMATCH_ERROR_MESSAGE.key, CHANGE_PASSWORD_MODAL.PASSWORD_MISMATCH_ERROR_MESSAGE.value));
    }
  };

  const onChangeScore = value => {
    setPasswordScore(value.score);
    let updatedValue = { ...password };
    updatedValue['new'] = value.password;
    setPassword(updatedValue);

    if (password.confirm.length === 0) return;
    passwordValidation(value.password, password.confirm);
  };

  useEffect(() => {
    if (password.confirm && password.new && PasswordScore >= 3 && password.old) {
      setFormValidityCheck(false);
    } else {
      setFormValidityCheck(true);
    }

  }, [password.confirm, password.new, PasswordScore, password.old])

  const preventAction = (e) => {
    e.preventDefault(); // Prevent the default paste behavior
  }

  return (
    <Container onKeyDown={e => e.stopPropagation()} onKeyPress={handleKeyPress}>
      <Modal
        title={PasswordUpdateSuccess ? "" : t(CHANGE_PASSWORD_MODAL.CHANGE_PASSWORD_TITLE.key, CHANGE_PASSWORD_MODAL.CHANGE_PASSWORD_TITLE.value)}
        centered
        maskClosable={false}
        visible={visible}
        width="625px"
        onCancel={onCancel}
        footer={PasswordUpdateSuccess ? [] : [
          <Button key="back" onClick={onCancel}>
            {t(CHANGE_PASSWORD_MODAL.CANCEL_BUTTON.key, CHANGE_PASSWORD_MODAL.CANCEL_BUTTON.value)}
          </Button>,
          <Button key="submit" type="primary" disabled={FormValidityCheck} loading={loading} onClick={submitPassword}>
            {loading ? t(CHANGE_PASSWORD_MODAL.CHANGING_PASSWORD_BUTTON_TEXT.key, CHANGE_PASSWORD_MODAL.CHANGING_PASSWORD_BUTTON_TEXT.value) : t(CHANGE_PASSWORD_MODAL.PROCEED_BUTTON.key, CHANGE_PASSWORD_MODAL.PROCEED_BUTTON.value)}
          </Button>,
        ]}
        className="warning-modal"
      >
        <ModalBody>
          <ModalContainer>
            {PasswordUpdateSuccess ?
              <PasswordContainer isValidPassword>
                <div className="lockContainer">
                  <input id="inpLock" type="checkbox" checked={true} />
                  <label class="btn-lock" for="inpLock">
                    <svg width="36" height="40" viewBox="0 0 36 40">
                      <path
                        class="lockb"
                        d="M27 27C27 34.1797 21.1797 40 14 40C6.8203 40 1 34.1797 1 27C1 19.8203 6.8203 14 14 14C21.1797 14 27 19.8203 27 27ZM15.6298 26.5191C16.4544 25.9845 17 25.056 17 24C17 22.3431 15.6569 21 14 21C12.3431 21 11 22.3431 11 24C11 25.056 11.5456 25.9845 12.3702 26.5191L11 32H17L15.6298 26.5191Z"
                      ></path>
                      <path
                        class="lock"
                        d="M6 21V10C6 5.58172 9.58172 2 14 2V2C18.4183 2 22 5.58172 22 10V21"
                      ></path>
                      <path class="bling" d="M29 20L31 22"></path>
                      <path class="bling" d="M31.5 15H34.5"></path>
                      <path class="bling" d="M29 10L31 8"></path>
                    </svg>
                  </label>
                </div>
                <div className='sucess_message'>{t(CHANGE_PASSWORD_MODAL.PASSWORD_UPDATE_SUCCESS_MESSAGE.key, CHANGE_PASSWORD_MODAL.PASSWORD_UPDATE_SUCCESS_MESSAGE.value)}</div>
              </PasswordContainer>

              : <>
                <InputContainer password={1}>
                  <InputLabel>{t(CHANGE_PASSWORD_MODAL.OLD_PASSWORD_LABEL.key, CHANGE_PASSWORD_MODAL.OLD_PASSWORD_LABEL.value)}</InputLabel>
                  <Input.Password
                    size="large"
                    name="old"
                    placeholder={t(CHANGE_PASSWORD_MODAL.OLD_PASSWORD_PLACEHOLDER.key, CHANGE_PASSWORD_MODAL.OLD_PASSWORD_PLACEHOLDER.value)}
                    value={password.old}
                    onChange={handlePassword}
                    onPaste={preventAction}
                    onCopy={preventAction}
                    maxLength={PASSWORD_MAX_LENGTH}
                  />
                  {passwordVerify &&
                    <InputLabel signUp error className="bottom_top_anime">
                      {t(CHANGE_PASSWORD_MODAL.PASSWORD_MISMATCH_ERROR_MESSAGE.key, CHANGE_PASSWORD_MODAL.PASSWORD_MISMATCH_ERROR_MESSAGE.value)}
                    </InputLabel>
                  }

                </InputContainer>
                <InputContainer password={1}>
                  <InputLabel>{t(CHANGE_PASSWORD_MODAL.NEW_PASSWORD_LABEL.key, CHANGE_PASSWORD_MODAL.NEW_PASSWORD_LABEL.value)}</InputLabel>
                  <PasswordStrengthBar onChangeScore={onChangeScore} />
                </InputContainer>
                <InputContainer password={1}>
                  <InputLabel>{t(CHANGE_PASSWORD_MODAL.CONFIRM_PASSWORD_LABEL.key, CHANGE_PASSWORD_MODAL.CONFIRM_PASSWORD_LABEL.value)}</InputLabel>
                  <Input.Password
                    size="large"
                    name="confirm"
                    placeholder={t(CHANGE_PASSWORD_MODAL.CONFIRM_PASSWORD_PLACEHOLDER.key, CHANGE_PASSWORD_MODAL.CONFIRM_PASSWORD_PLACEHOLDER.value)}
                    value={password.confirm}
                    onChange={handlePassword}
                    onPaste={preventAction}
                    onCopy={preventAction}
                    maxLength={PASSWORD_MAX_LENGTH}
                  />
                  {error &&
                    <InputLabel signUp error className="bottom_top_anime">
                      {error}
                    </InputLabel>
                  }
                </InputContainer>
              </>}

          </ModalContainer>
        </ModalBody>
      </Modal>
    </Container>
  );
};

export default withTranslation(['CHANGE_PASSWORD_MODAL'])(ChangePasswordModal);

